module.exports = "/to_the_arctic_for_practice/_next/static/videos/10-88f97f90c1cf8b52a95ea88b55ecd4be.mp4";